import { render, staticRenderFns } from "./PageManagerSet.vue?vue&type=template&id=8ae42d1a&scoped=true"
import script from "./PageManagerSet.vue?vue&type=script&lang=js"
export * from "./PageManagerSet.vue?vue&type=script&lang=js"
import style0 from "./PageManagerSet.vue?vue&type=style&index=0&id=8ae42d1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae42d1a",
  null
  
)

export default component.exports